import React, { useEffect, useState } from "react";
import { Fab, useTheme, Zoom } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

/**
 * ScrollToTopButton
 * - jobb alsó sarokban lebegő gomb (FAB) felfelé nyíllal
 * - >300px görgetés után jelenik meg
 * - kattintásra sima görgetés az oldal tetejére
 * - figyelembe veszi a prefers-reduced-motion beállítást
 */
const ScrollToTopButton: React.FC = () => {
  const theme = useTheme();
  const [visible, setVisible] = useState(false);

  // reduced motion támogatás (ha a felhasználó csökkentett mozgást kér)
  const [reducedMotion, setReducedMotion] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    const handler = () => setReducedMotion(Boolean(mq && mq.matches));
    handler();
    if (mq && mq.addEventListener) mq.addEventListener("change", handler);
    else if (mq && (mq as any).addListener) (mq as any).addListener(handler);
    return () => {
      if (mq && mq.removeEventListener) mq.removeEventListener("change", handler);
      else if (mq && (mq as any).removeListener) (mq as any).removeListener(handler);
    };
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 300);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Arany/sárga színek: világos és sötét módhoz külön árnyalat
  const bg = theme.palette.mode === "dark" ? "#ffdd57" : "#f5c542";
  const hoverBg = theme.palette.mode === "dark" ? "#ffcc00" : "#f0b429";
  const iconColor = theme.palette.mode === "dark" ? "rgba(0, 0, 0, 0.87)" : "rgba(0,0,0,0.87)";

  return (
    <div
      aria-hidden={false}
      style={{
        position: "fixed",
        right: 20,
        bottom: 20,
        zIndex: 1400,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      {reducedMotion ? (
        visible && (
          <Fab
            onClick={handleClick}
            aria-label="Gördess fel az oldal tetejére"
            sx={{
              backgroundColor: bg,
              color: iconColor,
              "&:hover": { backgroundColor: hoverBg },
            }}
            size="medium"
          >
            <ArrowUpwardIcon />
          </Fab>
        )
      ) : (
        <Zoom in={visible} unmountOnExit>
          <Fab
            onClick={handleClick}
            aria-label="Gördess fel az oldal tetejére"
            sx={{
              backgroundColor: bg,
              color: iconColor,
              "&:hover": { backgroundColor: hoverBg, transform: "translateY(-2px)" },
              boxShadow:
                theme.palette.mode === "dark"
                  ? "0 6px 18px rgba(255,221,87,0.12)"
                  : "0 8px 20px rgba(240,180,41,0.14)",
            }}
            size="medium"
          >
            <ArrowUpwardIcon />
          </Fab>
        </Zoom>
      )}
    </div>
  );
};

export default ScrollToTopButton;
